import React, { useState } from 'react';
import { CollectionItemTab } from './CollectionItemTab';
import { CollectionActivityDrop } from './CollectionActivityDrop';
import { CollectionLiveTab } from './CollectionLiveTab';

const CollectionTabs = ({ contractAddress }) => {
  // State to manage the active tab
  const [activeTab, setActiveTab] = useState('Items');

  // Function to handle tab click and update the active state
  const handleTabClick = (tabName) => {
    setActiveTab(tabName);
  };

  return (
    <div className="main-container">
      <div className="tab-container">
        {/* Tab navigation */}
        <div className="tabs">
          {['Items', 'Activity', 'Live'].map((tabName) => (
            <div
              key={tabName}
              className={`tab ${activeTab === tabName ? 'active' : ''}`}
              onClick={() => handleTabClick(tabName)}
            >
              {tabName}
            </div>
          ))}
        </div>

        {/* Tab content area */}
        <div className="tab-content">
          {activeTab === 'Items' && <CollectionItemTab contractAddress={contractAddress} />}
          {activeTab === 'Activity' && <CollectionActivityDrop contractAddress={contractAddress} />}
          {activeTab === 'Live' && <CollectionLiveTab contractAddress={contractAddress} />}
        </div>
      </div>
    </div>
  );
};

export default CollectionTabs;
